import { CropLandscapeOutlined } from "@mui/icons-material";
import axios from "axios";


export const getReturns = async () => {
    //console.log ("getReturns");
    const response = await axios.get("api/returns");
    const result = response.data;
    return result;
}

export const getReturn = async (id) => {
    const response = await axios.get("api/returns/" + id);
    const result = response.data;
    return result;
}

export const getReturnsGroupedByCustomer = async () => {
    const response = await axios.get("api/returns/groupedbycustomer");
    const result = response.data;
    return result;
}

export const postReturn = async (data) => {
    const response = await axios.post("api/returns", data);
    const result = response.data;
    return result;
}

export const patchReturn = async (data) => {
    const response = await axios.patch("api/returns", data);
    const result = response.data;
    return result;
}

export const cancelReturn = async (id) => {
    const response = await axios.delete("api/returns/" + id);
    const result = response.data;
    return result;
}

export const deliverReturnOrderRow = async (data) => {
    console.log("deliverReturnOrderRow", data)
    const response = await axios.post("api/returns/deliverrow" , data);
    const result = response.data;
    return result;
}

export const closeReturnOrder = async (orderId) => {
    console.log("closeReturnOrder")
    const response = await axios.post("api/returns/closeorder?orderId=" + orderId);
    const result = response.data;
    return result;
}



// export const postDimension = async (data) => {
//     const response = await axios.post("api/taskdimensions", data);
//     const result = response.data;
//     return result;
// }

// export const deleteDimension = async (dimensionId) => {
//     console.log("delete ", dimensionId)
//     const response = await axios.delete(`api/taskdimensions/${dimensionId}`);
//     const result = response.data;
//     return result;
// }


// export const postDimensionValue = async (data) => {
//     const response = await axios.post("api/taskdimensions/values", data);
//     const result = response.data;
//     return result;
// }

// export const deleteDimensionValue = async (dimensionValueId) => {
//     console.log("delete ", dimensionValueId)
//     const response = await axios.delete(`api/taskdimensions/values/${dimensionValueId}`);
//     const result = response.data;
//     return result;
// }
